// Constants and Utils
import {
  formatText,
  toLocaleString,
} from "../../../common-utils/string-utils/StringUtils";
import {
  checkAnyValuePresentForKeys,
  constructCityReachSplit,
} from "../GraphReportsUtils";
import { ReachSplitBarDataKeys } from "../GraphReportsConstants";

// Components
import { BarChart } from "../../../components/charts/Charts";
import TableHeaders from "../../../components/table/TableHeaders";
import { NoChartDataMessage } from "../GraphReportUtils";

// Page Constants
const tableHeaders = [
  {
    title: {
      displayName: "City",
      className: "col-4 text-center",
    },
  },
  {
    title: {
      displayName: "Reach",
      className: "col-4 text-center",
    },
  },
  {
    title: {
      displayName: "TG Reach",
      className: "col-4 text-center",
    },
  },
];

// Reach Split Table Section
function ReachSplitTableSection({
  infoByCity = {},
  targetGroupId,
  isCustomTgSelected = false,
}) {
  // final tg select check
  const isAnyTgSelected = targetGroupId || isCustomTgSelected;

  return (
    <div className="col-5 table-responsive max-h-400 thick-scrollbar">
      <table className="table">
        {/* Table- Header */}
        <TableHeaders requiredSubHeader={false} tableHeaders={tableHeaders} />

        <tbody>
          {Object.values(infoByCity).map((cityInfo) => {
            const { cityName, cityId, reachFrequency = {} } = cityInfo;
            const { reach, tgReach } = reachFrequency;

            // final tgReachString
            const finalTgReachStr = isAnyTgSelected
              ? formatText(toLocaleString(tgReach))
              : `NA`;

            return (
              <tr key={cityId}>
                <td className="text-center text-primary">{cityName}</td>
                <td className="text-center">
                  {formatText(toLocaleString(reach))}
                </td>
                <td className="text-center">{finalTgReachStr}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

// Reach Split Graph Section
function ReachSplitGraphSection({ infoByCity = {} }) {
  // reach Split Data
  const reachSplitData = constructCityReachSplit(infoByCity);

  // check for data
  const hasReachSplitDataForAnyCity = checkAnyValuePresentForKeys(
    reachSplitData,
    ReachSplitBarDataKeys
  );

  return (
    <div className="col-7">
      <h4 className="font-weight-bold pr-2 mb-0">
        City Wise Reach V/s TG-Reach Split
      </h4>

      {/* bar chart */}
      <div className="px-4 pt-4">
        {!hasReachSplitDataForAnyCity && (
          <NoChartDataMessage message="Reach Split Not Present For Any City" />
        )}
        {hasReachSplitDataForAnyCity && (
          <BarChart
            data={reachSplitData}
            barsData={ReachSplitBarDataKeys}
            showCartesianGrid={true}
            showCustomXAxisTick={true}
          />
        )}
      </div>
    </div>
  );
}

/**
 * Campaign Reach Split Section
 */
export default function CampaignReachSplitSection({
  infoByCity = {},
  targetGroupId,
  isCustomTgSelected = false,
}) {
  return (
    <div className="row py-4 border-bottom">
      {/* graph */}
      <ReachSplitGraphSection infoByCity={infoByCity} />

      {/* Table */}
      <ReachSplitTableSection
        infoByCity={infoByCity}
        targetGroupId={targetGroupId}
        isCustomTgSelected={isCustomTgSelected}
      />
    </div>
  );
}
